<template>
    <div class="login_d1 flex j-c a-c">
        <img :src="require('~a/imgs/4.png')" />
        <slot v-if="device !== 'mobile'"></slot>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    computed: {
        ...mapGetters(["device"])
    }
}
</script>

<style scoped>
.login_d1 {
    width: 100%;
    height: 120px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 24px;
    color: #333333;
}

.login_d1 img {
    width: 280px;
    height: 79px;
    margin-right: 43px;
}
</style>